export default __webpack_public_path__ + "static/media/Thug's Arm-straps of the Firebringer.25217ba8.jpg";